import api from './api'; // tu instancia axios

export const getNotificationTypes = () =>
  api.get('/notifications/types').then(r => r.data);

export const getNotificationsByStore = (storeId) =>
  api.get('/notifications', { params: { storeId } }).then(r => r.data);

export const getUsersForStore = (storeId) =>
  api.get('/notifications/users', { params: { storeId } }).then(r => r.data);

export const toggleNotification = (id) =>
  api.patch(`/notifications/${id}/toggle`).then(r => r.data);

export const updateRecipients = (id, userIds) =>
  api.put(`/notifications/${id}/recipients`, { userIds }).then(r => r.data);